import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { editSection, getSection } from "store/actions";
import Loader from "components/shared/Loader";
import { useState } from "react";
import { Input, Textarea } from "components/shared/FormComponents";
import SaveChangesButton from "components/shared/SaveChangesButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import SlidersArray from "./SliderArray";
import ImageUpdateValue from "../../components/shared/ImageUpdateValue";
import SlidersArrayTeam from "./SlidersArrayTeam";

const Section = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const { loading, error, section } = useSelector((state) => state.section);
  const [sliders, setSliders] = useState([]);
  const [slidersTeam, setSlidersTeam] = useState([]);
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm();

  // get single page by slug
  useEffect(() => {
    dispatch(
      getSection({
        page: "home",
        slug: "aboutUs",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    reset(section);

    setSliders(section?.sliders);
    setSlidersTeam(section?.team);
  }, [reset, section]);

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    data.sliders = sliders;
    data.team = slidersTeam;

    dispatch(
      editSection({ slug: "aboutUs", page: "home", data: { section: data } })
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"about"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col md={12}>
                <Row>
                  <Col lg={12}>
                    <SlidersArray sliders={sliders} setSliders={setSliders} />
                  </Col>
                </Row>
                <hr />
                <Row className="form-group">
                  <h5 className="fs-4">
                    <FormattedMessage id="secondSection" />
                  </h5>
                  <Col xs="12" md="6">
                    <Controller
                      name="secondSectionImage"
                      control={control}
                      rules={{ required: true }}
                      render={({ field: { value, onChange } }) => (
                        <ImageUpdateValue
                          title="image"
                          value={value}
                          setValue={(value) => onChange(value)}
                        />
                      )}
                    />
                  </Col>
                  <Col xs="12" md="6">
                    <Controller
                      name="secondSectionSignature"
                      control={control}
                      // rules={{ required: true }}
                      render={({ field: { value, onChange } }) => (
                        <ImageUpdateValue
                          title="signature"
                          value={value}
                          required={false}
                          setValue={(value) => onChange(value)}
                        />
                      )}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      required={false}
                      langId="subHeading"
                      name="secondSectionSubHeading.ar"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      required={false}
                      langId="subHeading"
                      name="secondSectionSubHeading.en"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      required={false}
                      langId="heading"
                      name="secondSectionHeading.ar"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      required={false}
                      langId="heading"
                      name="secondSectionHeading.en"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Textarea
                      langId="description"
                      name="secondSectionDescription.ar"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Textarea
                      langId="description"
                      name="secondSectionDescription.en"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                </Row>
                <hr />
                <Row className="form-group">
                  <h5 className="fs-4">
                    <FormattedMessage id="team" />
                  </h5>
                  <Col lg={6} xs={12}>
                    <Input
                      required={false}
                      langId="teamSubTitle"
                      name="teamSubTitle.ar"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      required={false}
                      langId="teamSubTitle"
                      name="teamSubTitle.en"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={6} xs={12}>
                    <Input
                      required={false}
                      langId="teamTitle"
                      name="teamTitle.ar"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      required={false}
                      langId="teamTitle"
                      name="teamTitle.en"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <SlidersArrayTeam
                      sliders={slidersTeam}
                      setSliders={setSlidersTeam}
                    />
                  </Col>
                </Row>

                <SaveChangesButton />
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Section;
